import { PageLink, PageTitle } from "_metronic/layout/core";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import DailyItinerary from "./components/DailyItinerary";
import WeeklyMeetings from "./components/WeeklyMeetings";
import ActionableCases from "./components/ActionableCases";
import { CPLModule } from "app/modules/shared/cplModules/CPLModule";
import { CPLModules } from "cpl-react-common/components/Enums/CPLModules";

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: "Dashboard",
    path: "/Dashboard",
    isSeparator: false,
    isActive: true,
  },
];

const DashboardPage = () => {
  return (
    <CPLAnalytics pageName="Dashboard">
      <PageTitle breadcrumbs={dashboardBreadCrumbs} />
      <div className="row g-5 g-xl-10 m-5 mb-xl-10">
        <CPLModule module={CPLModules.Scheduling}>
          <div className="col-lg-3">
            <DailyItinerary />
          </div>
        </CPLModule>
        <CPLModule module={CPLModules.Cases}>
          <div className="col-lg-3">
            <ActionableCases />
          </div>
        </CPLModule>
        <CPLModule module={CPLModules.Scheduling}>
          <div className="col-lg-6">
            <WeeklyMeetings />
          </div>
        </CPLModule>
      </div>
    </CPLAnalytics>
  );
};

export default DashboardPage;
